export default __webpack_public_path__ + "static/leader_2-3e140e010ec557fa1e7305871cd39f31.png";